module.exports = __webpack_public_path__ + "img/supervision-1.b20d38af.png";